export const email = "adammusial1906@gmail.com";
